import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Button, Form, message, Row, Col, Input, Result, Modal } from "antd";
import {
  validateForgetPasswordKey,
  resetForgetPasswordKey,
} from "apis/authentication";
import FormInput from "components/FormInput/FormInput";
import {
  ArrowLeftOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { withAppContext } from "contexts/AppContext/AppContext";
import { buildLoginUri } from "utils/routes";
import ReCAPTCHA from "react-google-recaptcha"; //Using V2

const { useForm } = Form;

const ForgotPassword = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = useForm();
  const [validateStatus, setValidateStatus] = useState(false);
  const [success_modal_visible, setsuccess_modal_visible] = useState(false);

  const { id } = useParams();
  const history = useHistory();

  console.log(useParams());

  useEffect(() => {
    ValidateForgetPasswordKey(id);
  }, []);

  const ValidateForgetPasswordKey = async (id) => {
    try {
      setLoading(true);
      const res = await validateForgetPasswordKey(id);
      console.log(res);

      setLoading(false);

      if (res === "OK") {
        setValidateStatus(true);
      }
    } catch (error) {
      setValidateStatus(false);
    }

    // setData(res);
    // if (res.status === 200) {
    //   setLoading(false);

    //   setData(res);
    // } else {
    //   setLoading(false);
    // }
  };

  const compareToFirstPassword = (rule, value) => {
    // const { form } = this.props;
    if (value && value !== form.getFieldValue("new_password")) {
      return Promise.reject("Password not match!");
    } else {
      return Promise.resolve();
    }
  };

  const handleResetPassword = async (values) => {
    setLoading(true);

    values.password = values.new_password;
    values.reset_password_key = id;

    delete values.confirm_password;
    delete values.new_password;

    console.log(values);
    const res = await resetForgetPasswordKey(values);
    console.log(res);

    setLoading(false);
    setsuccess_modal_visible(true);
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  const SuccessModal = (
    <Modal
      visible={success_modal_visible}
      centered={true}
      closable={false}
      footer={null}
    >
      <Result
        status="success"
        title="Reset Password Successful!"
        subTitle="Congratulation, you had successfully updated your new password"
        extra={[
          <Button
            style={{
              backgroundColor: "#d7a301",
              borderRadius: 5,
              color: "#fff",
            }}
            key="login"
            onClick={() => history.push(buildLoginUri())}
          >
            Back to Login
          </Button>,
        ]}
      />
    </Modal>
  );

  const ResetPassword = (
    <div>
      <Row
        justify="center"
        style={{
          padding: "16vh 0px 16vh",
        }}
      >
        <Col
          style={{
            width: 1200,
          }}
        >
          <Row justify="center">
            <Col
              style={{
                backgroundColor: "rgba(255,255,255,0.8)",
                width: 500,
                borderRadius: 20,
                padding: 40,
              }}
            >
              <Row type="flex" justify="center">
                <Col
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    marginBottom: 16,
                  }}
                >
                  Reset Password
                </Col>
              </Row>

              <Form
                form={form}
                name="resetPasswordForm"
                layout="vertical"
                hideRequiredMark
                onFinish={handleResetPassword}
                {...formItemLayout}
                className="antd-input-password-style"
              >
                <Form.Item
                  label="New Password"
                  name="new_password"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please insert new password",
                    },
                    {
                      // pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\W_]{8,}$/,
                      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{12,20}$/,
                      message: "Please refer to below password policy",
                    },
                  ]}
                >
                  <Input.Password
                    style={{
                      //   background: "transparent",
                      border: "1px solid rgba(0,0,0,0.45)",
                      borderRadius: 5,
                    }}
                  />
                </Form.Item>
                <Form.Item label="Password Must" shouldUpdate>
                  {(e) => {
                    const password = e.getFieldValue("new_password");
                    console.log(password);

                    let small_case_pattern = /(?=.*[a-z])/;
                    let small_case = small_case_pattern.test(password);

                    let upper_case_pattern = /(?=.*[A-Z])/;
                    let upper_case = upper_case_pattern.test(password);

                    let number_pattern = /(?=.*[0-9])/;
                    let number_case = number_pattern.test(password);

                    let char_12_pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{12,20}$/;
                    let char_12 = char_12_pattern.test(password);

                    console.log(small_case, upper_case, char_12, number_case);
                    return (
                      <>
                        <div>
                          {number_case ? (
                            <CheckOutlined style={{ color: "green" }} />
                          ) : (
                            <CloseOutlined style={{ color: "red" }} />
                          )}
                          <span style={{ marginLeft: 8 }}>
                            Include at least one number.
                          </span>
                        </div>
                        <div>
                          {small_case && upper_case ? (
                            <CheckOutlined style={{ color: "green" }} />
                          ) : (
                            <CloseOutlined style={{ color: "red" }} />
                          )}
                          <span style={{ marginLeft: 8 }}>
                            Include both lower and upper case letters.
                          </span>
                        </div>
                        <div>
                          {char_12 ? (
                            <CheckOutlined style={{ color: "green" }} />
                          ) : (
                            <CloseOutlined style={{ color: "red" }} />
                          )}
                          <span style={{ marginLeft: 8 }}>
                            Contain minimum 12 characters and condition above
                          </span>
                        </div>
                      </>
                    );
                  }}
                </Form.Item>
                <Form.Item
                  label="Confirm Password"
                  name="confirm_password"
                  hasFeedback
                  dependencies={["new_password"]}
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password",
                    },
                    {
                      validator: compareToFirstPassword,
                    },
                  ]}
                >
                  <Input.Password
                    style={{
                      //   background: "transparent",
                      border: "1px solid rgba(0,0,0,0.45)",
                      borderRadius: 5,
                    }}
                  />
                </Form.Item>

                <Row type="flex" justify="center">
                  <Form.Item
                    hasFeedback
                    name="reCaptcha"
                    rules={[
                      {
                        required: true,
                        message: "Recaptcha is required",
                        // type: "string"
                      },
                    ]}
                  >
                    <ReCAPTCHA
                      //   ref={recaptcha}
                      sitekey="6LcTRr0eAAAAANsQsmNk4yqAP4_jcIFq1j0L2YUR"
                      onChange={(e) => {
                        console.log(e);
                      }}
                    />
                  </Form.Item>
                </Row>

                <Row justify="center">
                  <Form.Item>
                    <Button
                      style={{
                        backgroundColor: "#d7a301",
                        borderRadius: 5,
                        width: 120,
                        height: 35,
                        color: "#fff",
                      }}
                      htmlType="submit"
                      loading={loading}
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );

  const LinkExpiredPage = (
    <div>
      <Row
        justify="center"
        style={{
          padding: "22vh 0px 22vh",
        }}
      >
        <Col
          style={{
            width: 1200,
          }}
        >
          <Row justify="center">
            <Col
              style={{
                backgroundColor: "rgba(255,255,255,0.8)",
                width: 600,
                borderRadius: 20,
                padding: 40,
              }}
            >
              <Result
                status="warning"
                title="Password reset link is expired, please reset your password again"
                extra={
                  <Button
                    style={{
                      backgroundColor: "#d7a301",
                      borderRadius: 5,
                      color: "#fff",
                    }}
                    key="console"
                    // onClick={() => props.router.push("/forgot-password")}
                    onClick={() => history.push("/login")}
                  >
                    Reset your password now
                  </Button>
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      {validateStatus ? ResetPassword : LinkExpiredPage}

      {SuccessModal}
    </div>
    // <div style={{ backgroundColor: "#fff", padding: 40, borderRadius: 5 }}>
    //   asdsadasd
    // </div>
  );
};

export default withAppContext(ForgotPassword);
